class ResizeObserverDetail {
    constructor(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
}
export { ResizeObserverDetail };
